import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { ClientType } from "@common/types/server-list-types";

export const getClientById = async (
  namespace: string,
  clientId: string,
  shouldRequestNodeset: boolean,
  shouldRequestConfiguration: boolean,
  signal?: AbortSignal,
) => {
  const url = clientConfigurationUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<ClientType>(
      `${url}/api/v3/ns/${namespace}/clients/${clientId}`,
      {
        headers: headers,
        params: {
          include_nodeset: shouldRequestNodeset,
          include_configuration: shouldRequestConfiguration,
        },
        signal,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        (typeof err.response?.data?.detail === "string" &&
          err.response?.data?.detail) ||
          (typeof err.response?.data?.message === "string" &&
            err.response?.data?.message) ||
          "Failed to fetch client information. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while fetching client information.",
      );
    }
  }
};
